import React, { useEffect, useState } from 'react';
import Footer from '../footer';
import Header from '../header';
import { useNavigate, useParams } from 'react-router-dom';
import { JournalList, JournalAtoZList } from "../../Redux/journal/journalslice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import ContentRenderer from '../ContentRender';
import FeatherIcon from "feather-icons-react";

const Journalfilter = () => {
    const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
    const { name } = useParams();
    const dispatch = useDispatch();
    const { journalList, atoz } = useSelector((state) => state.jounalListData);

    
    const [search, setSearch] = useState('')
    useEffect(() => {
        dispatch(JournalList(name));
        dispatch(JournalAtoZList(search));
    }, [name]);

    const [selectedLetter, setSelectedLetter] = useState('A');

    const handleLetterClick = (letter) => {
        setSelectedLetter(letter);
        window.scrollTo(0, 0);
        const section = document.getElementById(`journal-${letter}`);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Check which letters have associated data
    const lettersWithData = new Set(atoz?.data?.map(item => item._id) || []);

    const navigation = useNavigate();

    const NavigateFun = (dataID, jounalsD) => {
        window.scrollTo(0, 0);
        navigation(`/${dataID?.journal_slug}/home`, {
            state: { journals: jounalsD } // 'state' is used to pass the data
        });
    }


    return (
        <>
            <Header />
            {/* 
            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="breadcrumb-list">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">Pages</li>
                                        <li className="breadcrumb-item">Support</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="page-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h1 className="mb-0">{journalList?.data?.page_heading}</h1>
                        </div>
                    </div>
                </div>
            </div> */}
            {/*  */}

            <div className="inner-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="instructor-wrap border-bottom-0 m-0">
                                <div className="about-instructor align-items-center"></div>
                            </div>
                            <h2>{"Journals Feed"}</h2>
                            {/* <p
                                dangerouslySetInnerHTML={{
                                  __html: homeJournalDataById?.data?.[0]?.journal_homes?.[0]?.about_journal,
                                }}
                                className="truncate-two-lines"
                              ></p> */}

                            <div
                                className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 justify-content-end"
                                style={{ justifyContent: "end" }}
                            >
                                <div className="row">
                                    <div className="col-md-12 col-12">
                                        <h1 className="h5 h4-md mb-0" style={{ color: "white" }}>{journalList?.data?.page_heading}</h1>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 justify-content-start"
                                style={{ justifyContent: "start" }}
                            />
                        </div>
                    </div>
                </div>
            </div>


            {/*  */}

            <div className='topspace container py-3'>
                <div className='card'>
                    <div className='card-body'>
                        {/* <div dangerouslySetInnerHTML={{ __html: journalList?.data?.page_content }}></div> */}
                        <ContentRenderer content={journalList?.data?.page_content} />
                    </div>
                </div>
                <Row>
                    <Col md={2} lg={2}>
                        {/* <h6 style={{ padding : '20px', backgroundColor : 'red', borderRadius : 8 ,}}>Journals by Title</h6> */}
                        <h6 style={{
                            padding: '10px',
                            backgroundColor: '#02CCFE',
                            borderRadius: '8px 0 0 8px',
                            color: 'white',
                            clipPath: 'polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%)'
                        }}>
                            Journals by Title
                        </h6>

                    </Col>
                    <Col md={10} lg={10}>
                        <div className="alphabet-container d-flex flex-wrap gap-2" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {alphabet.map(letter => (
                                <div
                                    key={letter}
                                    className={`alphabet-letter ${!lettersWithData.has(letter) ? 'disabled' : ''}`}
                                    style={{
                                        backgroundColor: selectedLetter === letter ? '#02CCFE' : '',
                                        cursor: lettersWithData.has(letter) ? 'pointer' : 'not-allowed',
                                        color: lettersWithData.has(letter) ? 'inherit' : '#ccc',
                                        padding: '8px',
                                        borderRadius: '4px'
                                    }}
                                    onClick={() => lettersWithData.has(letter) && handleLetterClick(letter)}
                                >
                                    {letter}
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
                <form
                    className="search-form w-100 w-md-auto mx-auto d-flex p-2"
                    style={{ padding: 10, width: '30%', marginLeft: 'auto', display: 'flex', justifyContent: 'center' }}
                >
                    <div className="input-group">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="form-control"
                            onChange={(event) => { 
                                dispatch(JournalAtoZList(event.target.value)); 
                                setSearch(event.target.value);
                                window.scrollTo(0, 0);
                            }}
                        />
                        {/* <button type="submit" className="btn btn-primary" onClick={(e) => SearchFun(e)}>
                            <i className="fa fa-search" />
                        </button> */}
                    </div>
                </form>

                {atoz?.data?.map((item, index) => (
                    <div key={index} id={`journal-${item._id}`} className='journal-section'>
                        <h3>{item?._id}</h3>
                        <div className='row pt-3'>
                            {item?.journals?.map((itemData, indexData) => {
                                console.log("Journal Data being passed:", itemData); // Debug log
                                return (
                                <div className='col-12 col-sm-6 col-md-3' key={indexData} >
                                    <div className='card'>
                                        <div className='card-body'>
                                            <div className="about-instructor">
                                                <div className="abt-instructor-img">
                                                    <img
                                                        src={itemData?.image_url}
                                                        alt="img"
                                                        onClick={() => NavigateFun(itemData, itemData?.journals)}
                                                        crossOrigin='anonymous'
                                                        className="img-fluid"
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </div>
                                                <div className="instructor-detail">
                                                    <h6 style={{ cursor: 'pointer' }} onClick={() => NavigateFun(itemData, itemData?.journals)}>
                                                        {itemData?.journal_name}
                                                    </h6>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className='all-btn all-category'>
                                                        <Link
                                                            // to={`/${itemData?.journal_slug}/journal-archive`}
                                                            to={`/${itemData?.journal_slug}/archive`}
                                                            className="btn btn-primary btn-sm"
                                                            state={{ data: itemData }}
                                                            style={{ fontSize: 10 }}
                                                            onClick={() => window.scrollTo(0, 0)}
                                                        >
                                                            <FeatherIcon icon="archive" /> Archive
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='all-btn all-category'>
                                                        <Link
                                                            to={`/${itemData?.journal_slug}/manuscript-form`}
                                                            state={{ data: itemData }}
                                                            className="btn btn-primary btn-sm"
                                                            style={{ fontSize: 10 }}
                                                            onClick={() => window.scrollTo(0, 0)}
                                                        >
                                                            <FeatherIcon icon="bookmark" /> Submit Paper
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-9'>
                                                    <p className="mb-1">Journal impact factor</p>
                                                </div>
                                                <div className='col-3'>
                                                    <p className="mb-1">{itemData?.impact_factor}</p>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-9'>
                                                    <p className="mb-1">Journal h-index</p>
                                                </div>
                                                <div className='col-3'>
                                                    <p className="mb-1">{itemData?.h_index}</p>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-9'>
                                                    <p className="mb-1">Journal cite Score</p>
                                                </div>
                                                <div className='col-3'>
                                                    <p className="mb-1">{itemData?.city_score}</p>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <p className="mb-1">Average acceptance to publication time ({itemData?.publication_time})</p>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <p className="mb-1">Average article processing time ({itemData?.processing_time})</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                            })}
                        </div>
                    </div>
                ))}
            </div>

            <Footer />
        </>
    )
}

export default Journalfilter;
